


















































import { computed, defineComponent, reactive, watch, ref, PropType, onMounted } from '@vue/composition-api';
import keyBy from 'lodash/keyBy';
import { useClipboard } from '@/common/util/copy';
import { updateQuery } from '@/common/util/url';
import { plTooltip, plButton } from '@ks/platform-ui';
import qrcode from '../qrcode/index.vue';
import { ShareModel, baseConfigParams, ExtTokenStoreParams } from '@/models/share';
import { useApolloModel } from 'vue-apollo-model';
import { useLog } from '@/common/log';
import { SHARE_TYPES, ShareType, useCardShare, useCopyTokenLog } from './social-share';

export default defineComponent({
    components: {
        plButton,
        qrcode,
        plTooltip,
    },
    props: {
        id: {
            type: String,
        },
        shareInfo: {
            type: Object as PropType<ExtTokenStoreParams>,
        },
        videoType: {
            type: String as PropType<'short-video' | 'video'>,
        },
        ignoreOptions: {
            type: Array as PropType<string[]>,
            default: () => [],
        },
        shareBaseConfig: {
            type: Object as PropType<baseConfigParams>,
            required: true,
        },
        logType: {
            type: String,
        },
        showShare: Boolean,
        qrSize: {
            type: String,
            default: '100px',
        },
    },
    setup(props, { root, emit }) {
        const log = useLog();
        const shareTypes = reactive<ShareType[]>(SHARE_TYPES);
        const shareTypesMap = reactive(keyBy(shareTypes, 'name'));

        const shareModel = useApolloModel(ShareModel);
        const shareUrlQueries = computed(() => {
            return updateQuery(root.$route.fullPath.split('?')[1], props.ignoreOptions);
        });
        const qrUrl = ref('');
        const tokenUrl = ref('');
        const curPhotoId = ref('');

        const url = ref('https://www.kuaishou.com/');
        onMounted(() => {
            url.value = `https://${window.location.host}/`;
        });


        async function handleGetShare() {
            const newPhotoId = props.id;
            if (newPhotoId) {
                await shareModel.handleTokenShare(newPhotoId, { config: props.shareBaseConfig, shareExtInfo: {
                    title: props.shareInfo?.title,
                    nickname: props.shareInfo?.nickname,
                    coverUrl: props.shareInfo?.coverUrl,
                    queries: shareUrlQueries.value,
                    photoId: newPhotoId,
                    videoType: props.videoType,
                } });
                tokenUrl.value = shareModel.tokenShareObj.tokenUrl as string;
            }
        }
        const { mainCopyMethod } = useClipboard('.copy-btn', tokenUrl);

        watch(() => props.showShare, async val => {
            const newPhotoId = props.id;
            if (newPhotoId && val && curPhotoId.value !== newPhotoId) {
                curPhotoId.value = newPhotoId;
                // id变化时，先处理token和QR的分享信息
                await shareModel.handleQrShare(newPhotoId, {
                    config: props.shareBaseConfig,
                    shareExtInfo: {
                        title: props.shareInfo?.title,
                        nickname: props.shareInfo?.nickname,
                        coverUrl: props.shareInfo?.coverUrl,
                        queries: shareUrlQueries.value,
                        photoId: newPhotoId,
                        videoType: props.videoType,
                    },
                });
                qrUrl.value = shareModel.qrShareObj.qrUrl as string;
                await handleGetShare();
            }
            val && log({
                type: 'SHOW',
                event_name: 'SHARE_POPUP_CARD',
            });
        }, {
            immediate: true,
        });

        function handleShare(shareType: ShareType) {
            useCardShare({
                shareType,
                shareModel,
                log,
                id: props.id as string,
                shareInfo: {
                    title: props.shareInfo?.title,
                    nickname: props.shareInfo?.nickname,
                    coverUrl: props.shareInfo?.coverUrl,
                    queries: shareUrlQueries.value,
                    photoId: props.id,
                    videoType: props.videoType,
                },
                shareConfig: props.shareBaseConfig,
                logType: props.logType,
            });
        }
        async function copy() {
            if (mainCopyMethod.value) {
                mainCopyMethod.value();
            }
            useCopyTokenLog(log, props.logType);
            emit('copy');
            await handleGetShare();
        }
        return {
            qrUrl,
            tokenUrl,
            shareTypes,
            shareTypesMap,
            handleShare,
            copy,
            url,
        };
    },
});
